<template>
    <!-- модалка планировки -->
    <modal name="sales_land_flat_card_crm_modal" @opened="FlatCardModalOpened" @closed="FlatCardModalClosed" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="isMobileChecker" id="sales_land_flat_card_crm_modal">
        <div class="modal-content land-flat-modal-content" v-if="modalData != null">
            <button class="btn-close-flat-card--modal" @click="closeFlatModal()"><svgIcon name="close" class="icon-close"/></button>

            <h3 v-if="isMobileChecker && projectHost != 'satpaev' && projectHost != 'nurly-dala2'" class="mobile-modal-title"><strong>{{modalData.rooms}}-</strong>{{flatsPage.flats_cards_info.flat_modal_title}}</h3>
            <h3 v-if="isMobileChecker && projectHost == 'satpaev' || projectHost == 'nurly-dala2'" class="mobile-modal-title"><strong>{{modalData.apartmentCode}}-</strong>{{flatsPage.flats_cards_info.flat_modal_title}}</h3>

            <div class="col-left" :class="{active: resizeCardImg}">
                <div class="btn-resize" :class="{active: resizeCardImg}" @click="resizeModalCardImg">
                    <svgIcon name="inresize" class="icon-inresize"/>
                    <svgIcon name="unresize" class="icon-unresize"/>
                </div>

                <div class="flat-card-big-img" v-if="modalData != null && modalData.id != null">
                    <div class="img-in" v-if="modalData.images.length > 0">
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '1')" :key="index+1">
                    </div>
                </div>
                <div class="flat-card-info-images" v-if="modalData != null && modalData.id != null">
                    <div class="col col-part" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '3')" :key="index+2"> 
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                    </div>
                    <div class="col col-plan" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '2')" :key="index+3"> 
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                    </div>
                    <div class="col col-rose" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '4')" :key="index+4" :class="{'estet-rose-horizontal': projectHost == 'estet' && getNumbersOfString(modalData.blockName) == 8 || getNumbersOfString(modalData.blockName) == 9}"> 
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                    </div>
                </div>

                <div class="flats-btns-container" v-if="!isMobileChecker">
                    <div class="flat-btn-print">
                        {{getIdPDF(modalData.images)}}
                        <a :href="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf" download target="_blank" class="btn-print" v-if="pdf != null">
                            <svgIcon name="pdf-download" class="icon-print"/>
                            <p>{{flats.land_flats_cards_info.flat_btn_download_name}}</p>
                        </a>
                    </div>
                    <div class="flat-btn-mail">
                        <a href="#" class="btn-mail" @click.prevent="InputMailInit"  v-if="!formActive && pdf != null"> 
                            <svgIcon name="mail" class="icon-mail"/>
                            <p>{{flats.land_flats_cards_info.flat_btn_mail_name}}</p>
                        </a>
                        <transition name="fade">
                            <formMail v-if="formActive"
                                    :options="[{pdf: 'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf, name: modalData.rooms + ' ком. квартира ' +  modalData.area + 'м²' + ' в ' + CapitalizeID(project) + '.pdf'}]"
                            ></formMail>
                        </transition>
                    </div>
                    <div class="flat-social-share-btns">
                        <button class="button btn-share-flat-to-social btn-share-flat-to-social-desctop" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.rooms + '-' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.area + ' м²' + ' в ЖК ' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf" data-web><svgIcon name="whatsapp-flat" class="flat-share-icon icon-whatsapp"/></button>
                        <button class="button btn-share-flat-to-social btn-share-flat-to-social-mobile" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.rooms + '-' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.area + ' м²' + ' в ЖК ' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf"><svgIcon name="whatsapp-flat" class="flat-share-icon icon-whatsapp"/></button>
                        <button class="button btn-share-flat-to-social" data-sharer="telegram" :data-title="'Ваша' + ' ' + modalData.rooms + '-' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.area + ' м²' + ' в ЖК ' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf"><svgIcon name="telegram" class="flat-share-icon icon-telegram"/></button>
                        <button class="button btn-share-flat-to-social" data-sharer="facebook" :data-hashtag="'МояКвартира_в_' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf"><svgIcon name="facebook-flat" class="flat-share-icon icon-facebook"/></button>
                    </div>
                </div>

            </div>

            <div class="col-right" v-if="modalData != null">
                <div class="flat-card-top-info">
                    <h3 v-if="!isMobileChecker && projectHost != 'satpaev' && projectHost != 'nurly-dala2'"><strong>{{modalData.rooms}}-</strong>{{flatsPage.flats_cards_info.flat_modal_title}}</h3>
                    <h3 v-if="!isMobileChecker && projectHost == 'satpaev' || projectHost == 'nurly-dala2'"><strong>{{modalData.apartmentCode}}-</strong>{{flatsPage.flats_cards_info.flat_modal_title}}</h3>

                    <!-- №{{modalData.number}} -->
                    <div class="item-info">
                        <ul>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_rooms}}
                                </div>
                                <div class="right">
                                    {{modalData.rooms}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_size}}
                                </div>
                                <div class="right">
                                    {{modalData.area}} <span>м²</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_floor}}
                                </div>
                                <div class="right">
                                    {{modalData.floor}}
                                </div>
                            </li>
                            <li class="price" v-if="saleItem.project_stie_shablon_price_flats_init == 'true' && modalData.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_price}} м²
                                </div>
                                <div class="right">
                                    <span>от</span> {{getNumber(modalData.meterPrice)}} <span>тг.</span>
                                </div>
                            </li>
                            <li class="price" v-if="saleItem.project_stie_shablon_price_flats_init == 'true' && modalData.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_full_price}}
                                </div>
                                <div class="right">
                                    <span>от</span> {{getFullPrice(modalData.meterPrice, modalData.area)}} <span>тг.</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_flat_number}}
                                </div>
                                <div class="right">
                                    {{modalData.number}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    <span v-if="modalData.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</span>
                                    <span v-else>{{flatsPage.flats_cards_info.flat_kvartal}}</span>
                                </div>
                                <div class="right" v-if="modalData.complexCode != 'DSV' && projectHost != 'landmark' && modalData.complexCode != 'SOH' && modalData.complexCode != 'MNC'">
                                    {{getNumbersOfString(modalData.blockName)}}
                                </div>
                                <div class="right" v-if="modalData.complexCode == 'DSV'">
                                    {{getNumbersOfBlockDiscovery(modalData.blockName)}}
                                </div>
                                <div class="right" v-if="projectHost == 'landmark'">
                                    {{getNumbersOfBlockLandmark(modalData.blockName)}}
                                </div>
                                <div class="right" v-if="modalData.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(modalData.blockName)}}
                                </div>
                                <div class="right" v-if="modalData.complexCode == 'MNC'">
                                    {{getNumbersOfBlockMonaco(modalData.blockName)}}
                                </div>
                            </li>
                            <li v-if="blockPart != null">
                                <div class="left">
                                    <span v-if="modalData.complexCode != 'SOH' && modalData.complexCode != 'MNC'">{{flatsPage.flats_cards_info.flat_part}}</span>
                                    <span v-else>{{flatsPage.flats_cards_info.flat_block}}</span>
                                </div>
                                <div class="right" v-if="projectHost == 'landmark' || modalData.complexCode == 'SOH' || modalData.complexCode == 'MNC'">
                                    {{ blockPart }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="flat-card-btns-container">
                    <div class="flats-btns-container flats-btns-container-mobile" v-if="isMobileChecker">
                        <div class="flat-btn-print">
                            {{getIdPDF(modalData.images)}}
                            <a :href="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf" download target="_blank" class="btn-print" v-if="pdf != null">
                                <svgIcon name="pdf-download" class="icon-print"/>
                                <p>{{flats.land_flats_cards_info.flat_btn_download_name}}</p>
                            </a>
                        </div>
                        <div class="flat-social-share-btns">
                            <button class="button btn-share-flat-to-social btn-share-flat-to-social-desctop" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.rooms + '-' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.area + ' м²' + ' в ЖК ' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf" data-web><svgIcon name="whatsapp-flat" class="flat-share-icon icon-whatsapp"/></button>
                            <button class="button btn-share-flat-to-social btn-share-flat-to-social-mobile" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.rooms + '-' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.area + ' м²' + ' в ЖК ' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf"><svgIcon name="whatsapp-flat" class="flat-share-icon icon-whatsapp"/></button>
                            <button class="button btn-share-flat-to-social" data-sharer="telegram" :data-title="'Ваша' + ' ' + modalData.rooms + '-' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.area + ' м²' + ' в ЖК ' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf"><svgIcon name="telegram" class="flat-share-icon icon-telegram"/></button>
                            <button class="button btn-share-flat-to-social" data-sharer="facebook" :data-hashtag="'МояКвартира_в_' + CapitalizeID(project)" :data-url="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf"><svgIcon name="facebook-flat" class="flat-share-icon icon-facebook"/></button>
                        </div>
                        <div class="flat-btn-mail" v-if="projectHost != 'nurly-dala2'">
                            <a href="#" class="btn-mail" @click.prevent="InputMailInit"  v-if="!formActive && pdf != null"> 
                                <svgIcon name="mail" class="icon-mail"/>
                                <p>{{flats.land_flats_cards_info.flat_btn_mail_name}}</p>
                            </a>
                            <transition name="fade">
                                <formMail v-if="formActive"
                                        :options="[{pdf: 'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf, name: modalData.rooms + ' ком. квартира ' +  modalData.area + 'м²' + ' в ' + CapitalizeID(project) + '.pdf'}]"
                                ></formMail>
                            </transition>
                        </div>
                        <!-- <div class="flat-by-btn" v-if="salesCard.project_stie_flats_filter_init == 'true'">
                            <a :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=book'" class="bron" target="_blank">
                                <svgIcon name="booking" class="icon-booking"/>
                                <p>Забронировать</p>
                            </a>
                        </div> -->
                    </div>
                </div>
                <div class="by-btns-group" v-if="saleFilterParams.project_stie_flats_filter_init == 'true'">
                    <div v-if="
                            modalData.complexCode == 'RIV' || 
                            modalData.complexCode == 'AUS' || 
                            modalData.complexCode == 'EVL' || 
                            modalData.complexCode == 'ZGR' || 
                            modalData.complexCode == 'EST' || 
                            modalData.complexCode == 'PRV' || 
                            modalData.complexCode == 'ОRI' || 
                            modalData.complexCode == 'STP' || 
                            modalData.complexCode == 'ALF' ||
                            projectHost == 'landmark'">
                        <a :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=book'" class="bron" target="_blank" 
                            v-if="modalData.isApartmentReserved"
                            >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                        </a>
                        <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                        <a :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=by'" class="by" target="_blank" 
                            v-if="modalData.hasJointVentureAgreement"
                            >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                        </a>
                        <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                    </div>
                    <div v-else>
                        <a :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=book'" class="bron" target="_blank" 
                            v-if="checkConfirmPurchase('book', modalData.complexCode, modalData.blockName)"
                            >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                        </a>
                        <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                        <a :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=by'" class="by" target="_blank" 
                            v-if="checkConfirmPurchase('by', modalData.complexCode, modalData.blockName)"
                            >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                        </a>
                        <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                    </div>
                </div>
                <div class="flat-card-form">
                    <div class="flat-card-form-titles">
                        <h3>{{salesCard.project_shablon_fields.shablon_form_flat_title}}</h3>
                        <p>{{salesCard.project_shablon_fields.shablon_form_flat_desc}}</p>
                    </div>
                    <formFields class="form-flats-card-setup"></formFields>
                </div>
            </div>
        </div>
    </modal>
    <!-- end -->
</template>

<script>
    import {mapGetters} from 'vuex'
    import formFields from '@/components/forms/form-flat.vue';
	import formMail from '@/components/forms/form-mail.vue';	
    import svgIcon from '@/components/partials/SvgIcon.vue';
    
    export default {
        name: 'sale-CRM-flats-modal',
        components: {
            formFields,
            formMail,
            svgIcon,
        },
        data () {
            return {
                projectHost: window.host,
                modalWidth: 1000,
				modalHeight: 700,
				// modalScroll: false,
				transitionName: 'pop-out',

                formActive: false,
                resizeCardImg: false,
                project: window.host,
                pdf: null,
                blockPart: null,
            }
        },
        computed: mapGetters({
            flatsPage: 'loadSalesFlatsPageData',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            flats: 'loadSalesCardPage',
            modalData: 'loadSalesLandModalDataArr',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = parseInt(this.blockPart);
                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getFullPrice(price, area) {
                const result = price * area;
                return this.getNumber(parseInt(result));
            },
            getIdPDF(arr) {
                var filItem = arr.filter(item => {
                    return item.typeCode == '5'
                });
                if (filItem.length) {
                    this.pdf = filItem[0].id;
                } else {
                    this.pdf = null;
                }
                // console.log(this.pdf);
            },
            FlatCardModalClosed() {
				this.formActive = false;
				window.body.removeClass('overflowTrue');
				// document.getElementById('secret-btns').classList.remove('hideAll');
                document.getElementById('header').classList.remove('notvisible');
                // document.getElementById('landNav').classList.remove('notvisible');
                // document.getElementById('footer').classList.remove('notvisible');
			},
			FlatCardModalOpened() {
				window.Sharer.init();
				window.body.addClass('overflowTrue');
				// document.getElementById('secret-btns').classList.add('hideAll');
				document.getElementById('header').classList.add('notvisible');
                // document.getElementById('landNav').classList.add('notvisible');
                // document.getElementById('footer').classList.add('notvisible');
			},
            closeFlatModal() {
				this.$modal.hide('sales_land_flat_card_crm_modal');
            },
            InputMailInit() {
				this.formActive = true;
            },
            resizeModalCardImg() {
				this.resizeCardImg = !this.resizeCardImg;
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                if (code != 'DSV' && code != 'LDM' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } 
                // else if (code == 'LDM') {
                //     blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                // } else if (code == 'SOH') {
                //     blockName = this.getNumbersOfBlockSoho(blockName);
                // } else if (code == 'MNC') {
                //     blockName = this.getNumbersOfBlockMonaco(blockName);
                // }
                // console.log(blockName, this.blockPart)

                if (param == 'book') { //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        return false;
                    } 
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                } else if (param == 'by') { //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        return false;
                    } 
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                } else {
                    return false;
                }
            },
            // setGridView(param) { 
			// 	this.$store.commit('gridView', param);
            // },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-modal.scss';
    @import '@/styles/components/forms/form-flat.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-modal-respond.scss';
</style>